import {h, Fragment} from "preact"
// CODE COMMENTED AND SLIGHTLY REFACTORED TO SOLVE THIS https://nostosolutions.atlassian.net/browse/FEA-11587
// if the commented code will be used again, please note that the errors that will show are from the missing backticks on the template literals


// import { SerpElement, useAppState, useCurrencyFormatting, useProductFilters } from "@nosto/preact";
// import { productImagePlaceholder } from "../helpers";
// import { useRef, useState, useEffect } from "preact/hooks";

// export default function Product({ product, isSidebarVisible }) {
//     const { format } = useCurrencyFormatting();
//     const [hoverImage, setHoverImage] = useState(null);
//     const sliderRef = useRef(null);
//     const [isDown, setIsDown] = useState(false);
//     const [startX, setStartX] = useState(0);
//     const [scrollLeft, setScrollLeft] = useState(0);
//     const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
    

//     const { filters } = useProductFilters()

//     const genderedCategories = ["Men's", "Women's", "Kids", "Boys", "Girls", "Toddler", "Infant"]
//     const titleSubheading = product.name.split(" ")[0]
   
//     // const isSaleSkuForSearch = window.location.search.includes("q=") && product?.skus[0]?.customFields?.find(field => field.key === 'custom-sale_product')?.value == "true" ? true : false;
//     const isSaleSkuForSearch = product?.skus[0].listPrice && product?.skus[0].listPrice > product?.skus[0].price

//     const isSalePage = (window.location.href.includes("/collections/sale") && !window.location.href.includes("q=")) || isSaleSkuForSearch;
//     const isCustomizerPage = window.location.href.includes("/collections/customizer");

//     let bestsellingSku = product.skus?.find(sku => (sku.customFields?.find(field => field.key === 'custom-bestseller')?.value === 'true' && sku.customFields?.find(field => field.key === 'custom-sale_product')?.value !== 'true'))
//     if(isSalePage) { 
//         bestsellingSku = product.skus?.find(sku => (sku.customFields?.find(field => field.key === 'custom-bestseller')?.value === 'true' && sku.customFields?.find(field => field.key === 'custom-sale_product')?.value === 'true'))
//     }
//     let chosenColorVariantCode = bestsellingSku?.id ? '?variant=' + bestsellingSku.id : ''

//     filters?.filter(filter => filter.name === 'Color').forEach(filter => {
//         if(product?.skus.find(sku => sku.customFields?.find(field => field.key === 'custom-base_color')?.value === filter.value)){
//             if(isSalePage){
//                 if(product.skus.find(sku => sku.customFields.find(field => field.key === 'custom-base_color')?.value === filter.value && sku.listPrice && sku.listPrice > sku.price)){
//                     chosenColorVariantCode = '?variant=' + product.skus.find(sku => sku.customFields.find(field => field.key === 'custom-base_color')?.value === filter.value && sku.listPrice && sku.listPrice > sku.price)?.id
//                 } else {
//                     chosenColorVariantCode = '?variant=' + product.skus.find(sku => (sku.listPrice && sku.listPrice > sku.price))?.id
//                 }
//             } else {
//                 chosenColorVariantCode = '?variant=' + product.skus.find(sku => sku.customFields.find(field => field.key === 'custom-base_color').value === filter.value)?.id
//             }
//             return
//         }
//     })

//     useEffect(() => {
//         const handleResize = () => setIsMobile(window.innerWidth < 768);
//         window.addEventListener("resize", handleResize);
//         return () => window.removeEventListener("resize", handleResize);
//     }, []);

//     const extractUniqueSwatches = (skus, isSalePage) => {
//         if (!Array.isArray(skus)) {
//             return [];
//         }
//         const uniqueSwatches = new Map();
//         skus.forEach((sku) => {
//             const hexField = sku.customFields.find(field => field.key === "custom-hex_code");
//             // const isOnSale = sku.customFields.find(field => field.key === "custom-sale_product");
//             const isOnSale = sku.listPrice && sku.listPrice > sku.price

//             if(sku.availability === 'OutOfStock') return

//             // if (isOnSale?.value === "true" && !isSalePage) return;  // Show only sale swatches on sale pages
//             if (isOnSale && !isSalePage) return;  // Show only sale swatches on sale pages
//             // if (isOnSale?.value === "false" && isSalePage) return; // Show only non-sale swatches on non-sale pages
//             if (!isOnSale && isSalePage) return; // Show only non-sale swatches on non-sale pages

//             if (hexField && !uniqueSwatches.has(hexField?.value)) {
//                 uniqueSwatches.set(hexField.value, [sku.imageUrl, sku.id]);
//             }
//         });
//         return Array.from(uniqueSwatches.entries());
//     };

//     const swatches = extractUniqueSwatches(product.skus || [], isSalePage);

//     //console.log('swatches: ', swatches)

//     const handleMouseDown = (e) => {
//         if (sliderRef.current) {
//             setIsDown(true);
//             setStartX(e.pageX - sliderRef.current.offsetLeft);
//             setScrollLeft(sliderRef.current.scrollLeft);
//         }
//     };

//     const handleMouseLeave = () => setIsDown(false);
//     const handleMouseUp = () => setIsDown(false);

//     const handleMouseMove = (e) => {
//         if (!isDown || !sliderRef.current) return;
//         e.preventDefault();
//         const x = e.pageX - sliderRef.current.offsetLeft;
//         const walk = (x - startX) * 5; // Scroll-fast
//         sliderRef.current.scrollLeft = scrollLeft - walk;
//     };

//     const handleSwatchAction = (imageUrl, e, skuId) => {
//         if (isMobile) {
//             setHoverImage(imageUrl);
//             e.target.closest(".ns-product-container").querySelectorAll("a").forEach((el) => {
//                 el.href = el.href.split("?")[0] + ?variant=${skuId}
//             })
//         }
//     };

//     // Sale vs Non-sale Logic - Swatches and Images
//     let selectedColorSuffix = window.location.href.includes('')
//     let prodUrl = product.url + chosenColorVariantCode;
//     let listPrice = bestsellingSku?.listPrice ? bestsellingSku.listPrice : product.listPrice,
//         paidPrice = bestsellingSku?.price ? bestsellingSku.price : product.price,
//         mainImg = bestsellingSku?.imageUrl ? bestsellingSku.imageUrl : product.skus[0].imageUrl ? product.skus[0].imageUrl : product.imageUrl,
//         altImg = mainImg,
//         skuSpecificaltImgSkuCode = isSalePage ? [...product?.skus]?.filter(sku => sku?.listPrice && sku.listPrice > sku.price)[0]?.customFields?.find(field => field.key === 'skucode')?.value : product?.skus[0]?.customFields?.find(field => field.key === 'skucode')?.value,
//         skuSpecificaltImg;
//         // if(product.alternateImageUrls && product.alternateImageUrls[0] != "") { altImg = product.alternateImageUrls[0] } 

//     // Display bestseller alternative image if such sku exists
//     if(bestsellingSku){
//         skuSpecificaltImgSkuCode = bestsellingSku?.customFields?.find(field => field.key === 'skucode')?.value
//     }

//     // look up other alternative images to match the sku set as a default
//     if(product.alternateImageUrls && skuSpecificaltImgSkuCode) { 
//         for(let i = 9; i > 1; i--){
//             if(product.alternateImageUrls?.find(img => img.includes(skuSpecificaltImgSkuCode.substring(0, skuSpecificaltImgSkuCode.indexOf('-')) + '_' + i))){
//                 skuSpecificaltImg = product.alternateImageUrls?.find(img => img.includes(skuSpecificaltImgSkuCode.substring(0, skuSpecificaltImgSkuCode.indexOf('-')) + '_' + i))
//             }
            
//         }        
//     } 

//     if(isCustomizerPage){
//         mainImg = product.imageUrl
//     }
    
//     if(isSalePage) { 
//         prodUrl = product.url + chosenColorVariantCode + (chosenColorVariantCode ? "&sale_value=true" : "?sale_value=true")
//         product.skus?.some(function(el) {
//             if(el.price < el.listPrice){
//                 listPrice = bestsellingSku?.listPrice ? bestsellingSku.listPrice : el.listPrice;
//                 paidPrice = bestsellingSku?.price ? bestsellingSku.price : el.price;
//                 mainImg = bestsellingSku?.imageUrl ? bestsellingSku.imageUrl : el.imageUrl;
//                 product.alternateImageUrls?.some(function(innerEl, idx) {
//                     if(innerEl == mainImg) {
//                         altImg = product.alternateImageUrls[idx + 1];
//                         // setHoverImage(null);
//                         return true;
//                     }
//                 })
//                 return true;
//             }
//         })
//     }

//     console.log("MAIN IMG", product.name, chosenColorVariantCode)

//     // for Customizer Button
//     let customizerBackgroundImg = ""
//     if(product.tags1.includes("is_customizable::True") && !product.tags1.includes("is_disable_customizer::True")) {
//         product.tags1?.some(function(tag) {
//             if(tag.includes("customizer_background_image")) {
//                 customizerBackgroundImg = tag.toString().split("::")[1].trim()
//             }
//         })
//     }

//     // const onImageError = () => imgRef.current.src=altImg;

//     return (
//         <SerpElement
//             as="div"
//             hit={product}
//             class="ns-product-container relative"
//         >
//             { product.tags1.includes("is_customizable::True") && !product.tags1.includes("is_disable_customizer::True") && (
//                 <button 
//                     data-gan={product.customFields.find(field => field.key === 'custom-gan')?.value}
//                     data-is-kids-graphic={product.tags1.includes("is_kids_graphic::True")} 
//                     data-is-hoodie-graphic={product.tags1.includes("is_hoodie_graphic::True")}
//                     data-is-tank-graphic={product.tags1.includes("is_tank_graphic::True")}
//                     data-customizer-background-img-url={customizerBackgroundImg}
//                     class="right-[5px] top-[5px] customizer-button body-12-med hover:bg-grey-6 ">
//                         <span class="customizer-button-text">Customize</span>
//                         <img srcset="" sizes=", undefinedpx" src="https://cdn.shopify.com/s/files/1/0686/8326/8417/files/customizer-icon.png?v=1728055689" alt="Customize this product" height="12" width="12" loading="lazy" class="image customizer-button-image w-[12px] block object-fit " />
//                 </button>
//             )}

//             { isCustomizerPage ? (
//                 <a class={ns-product-image-container customizer-product-card ${skuSpecificaltImg ? 'ns-multiple-images' : ''}}
//                     href="#customizer" 
//                     data-gan={product.customFields.find(field => field.key === 'lig-master_id')?.value}
//                     data-customizer-background-img-url={customizerBackgroundImg}
//                     data-is-custom-product="true"
//                     data-is-kids-graphic={product.tags1.includes("is_kids_graphic::True")}
//                     data-is-hoodie-graphic={product.tags1.includes("is_hoodie_graphic::True")}
//                     data-is-tank-graphic={product.tags1.includes("is_tank_graphic::True")}
//                 >
//                     <div class="ns-badges-container">
//                         {(paidPrice < listPrice && window.location.href.indexOf('collections/sale') === -1) && (
//                             <span class="ns-sale-badge">On Sale!</span>
//                         )}
//                         {(product.tags1?.includes("badge::new") && window.location.href.indexOf('collections/new') === -1) && (
//                             <span class="ns-new-badge">New!</span>
//                         )}
//                     </div>

//                     <img
//                         class={product.alternateImageUrls?.length > 0 && !isCustomizerPage ? "ns-primary-image" : "ns-regular-image"}
//                         src={${ mainImg || hoverImage || productImagePlaceholder}&width=400}
//                         alt={Product image for "${product.name}" ||${ mainImg?.substring(mainImg?.lastIndexOf('/') + 1, mainImg?.indexOf('.jpg')) || hoverImage?.substring(hoverImage?.lastIndexOf('/') + 1, hoverImage?.indexOf('.jpg')) || ''} }
//                         width="600"
//                         height="400"
//                     />

//                     {product.alternateImageUrls?.length > 0 && !isCustomizerPage && altImg != "" && !hoverImage && (
//                         <img
//                             class="ns-secondary-image"
//                             src={${skuSpecificaltImg || altImg || productImagePlaceholder}&width=400}
//                             alt={Product image for "${product.name}" ||${ skuSpecificaltImg?.substring(skuSpecificaltImg?.lastIndexOf('/') + 1, skuSpecificaltImg?.indexOf('.jpg')) || altImg?.substring(altImg.lastIndexOf('/') + 1, altImg?.indexOf('.jpg')) || ''} }
//                             width="600"
//                             height="400"
//                             // onError={onImageError}
//                         />
//                     )}
//                 </a>
//             ) : (
//                 <a href={prodUrl} class={ns-product-image-container ${skuSpecificaltImg ? 'ns-multiple-images' : ''}}>
//                     <div class="ns-badges-container">
//                         {(paidPrice < listPrice && window.location.href.indexOf('collections/sale') === -1) && (
//                             <span class="ns-sale-badge">On Sale!</span>
//                         )}
//                         {(product.tags1?.includes("badge::new") && window.location.href.indexOf('collections/new') === -1) && (
//                             <span class="ns-new-badge">New!</span>
//                         )}
//                     </div>

//                     <img
//                         class={product.alternateImageUrls?.length > 0 && !isCustomizerPage && !isMobile ? "ns-primary-image" : "ns-regular-image"}
//                         src={${hoverImage || mainImg || productImagePlaceholder}&width=400}
//                         alt={Product image for "${product.name}" ||${ hoverImage?.substring(hoverImage?.lastIndexOf('/') + 1, hoverImage?.indexOf('.jpg')) || mainImg?.substring(mainImg?.lastIndexOf('/') + 1, mainImg?.indexOf('.jpg')) || ''} }
//                         width="600"
//                         height="400"
//                     />

//                     {!isMobile && product.alternateImageUrls?.length > 0 && !isCustomizerPage && altImg != "" && !hoverImage && (
//                         <img
//                             class="ns-secondary-image"
//                             src={${skuSpecificaltImg || altImg || productImagePlaceholder}&width=400}
//                             alt={Product image for "${product.name}" ||${ skuSpecificaltImg?.substring(skuSpecificaltImg?.lastIndexOf('/') + 1, skuSpecificaltImg?.indexOf('.jpg')) || altImg?.substring(altImg?.lastIndexOf('/') + 1, altImg?.indexOf('.jpg')) || ''} }
//                             width="600"
//                             height="400"
//                             // onError={onImageError}
//                         />
//                     )}
//                 </a>
//             )}

//             {swatches.length > 0 && (
//                 <div class="ns-swatches-container">
//                     <div
//                         class="ns-swatches-inner"
//                         onMouseDown={handleMouseDown}
//                         onMouseLeave={handleMouseLeave}
//                         onMouseUp={handleMouseUp}
//                         onMouseMove={handleMouseMove}
//                         ref={sliderRef}swatches
//                     >
//                         <div class="ns-swatches">
//                             {swatches.map(([hexCode, [imageUrl, id]], index) => (
//                                 <span
//                                     key={index}
//                                     class={ns-swatch-item ${imageUrl === bestsellingSku?.imageUrl ? 'ns-bestselling-swatch' : ''}}
//                                     style={{ backgroundColor: hexCode }}
//                                     onMouseEnter={() => !isMobile && setHoverImage(imageUrl)}
//                                     onMouseLeave={() => !isMobile && setHoverImage(null)}
//                                     onClick={(e) => {
//                                         if (isMobile) {
//                                             handleSwatchAction(imageUrl, e, id);
//                                         } else {
//                                             let saleParam = "";
//                                             if(isSalePage) { saleParam = "&sale_value=true"; }
//                                             window.location.href = ${product.url}?variant=${id}${saleParam};
//                                         }
//                                     }}
//                                 ></span>
//                             ))}
//                         </div>
//                     </div>
//                     {((!isMobile && swatches.length > 6) || (isMobile && swatches.length > 4)) && (
//                         <span class="ns-more-swatches"
//                             onClick={(e) => { e.currentTarget.closest(".ns-swatches-container").classList.toggle("showSwatches") }}>
//                             <svg width="15" height="12" viewBox="0 0 15 12" fill="none" xmlns="http://www.w3.org/2000/svg">
//                                 <path d="M5 1L11 6L5 11" stroke="#0A4875" stroke-linecap="round" />
//                             </svg>
//                         </span>
//                     )}
//                 </div>
//             )}

//             <div class="ns-relative ns-product-info" data-nosto-element="product">
//                 {!isCustomizerPage && paidPrice != 0 ? (
//                     <>
//                         <div class="ns-product-category">
//                             <span class={${!genderedCategories.includes(titleSubheading) ? 'ns-transparent' : ''}}>{titleSubheading}</span>
//                             {/* {!product.brand.toLowerCase() === 'life is good' ? 
//                                 <span>{product.brand}</span>
//                                 :
//                                 product.customFields?.find(field => field.key === 'custom-department').value === 'Accessories' ?
//                                 <span class="ns-category-placeholder"></span>
//                                 // <span>{product.customFields?.find(field => field.key === 'custom-style_category').value}</span>
//                                 :
//                                 <span class={${!genderedCategories.includes(titleSubheading) ? 'ns-transparent' : ''}}>{titleSubheading}</span>                                
//                             } */}
//                         </div>
//                         {/* { isCustomizerPage ? (
//                             <a class="customizer-product-card"
//                                 href="#customizer" 
//                                 data-gan={product.customFields.find(field => field.key === 'lig-master_id')?.value}
//                                 data-customizer-background-img-url={customizerBackgroundImg}
//                                 data-is-custom-product="true"
//                                 data-is-kids-graphic={product.tags1.includes("is_kids_graphic::True")}
//                                 data-is-hoodie-graphic={product.tags1.includes("is_hoodie_graphic::True")}
//                                 data-is-tank-graphic={product.tags1.includes("is_tank_graphic::True")}
//                             >
//                                 <div class="ns-product-name">{product.name.split(" ").slice(1).join(" ")}</div>
//                             </a>
//                         ) : (
//                             <a href={prodUrl}>
//                                 <div class="ns-product-name">{product.brand.toLowerCase() === 'life is good' ? product.name.split(" ").slice(1).join(" ") : product.name}</div>
//                             </a>
//                         )} */} 
//                         {/* product.customFields?.find(field => field.key === 'custom-style_category').value */}
//                         <a href={prodUrl}>
//                                 <div class="ns-product-name">
//                                     {/* {
//                                     !product.brand.toLowerCase() === 'life is good' ? 
//                                     product.name.replace(product.brand, '') 
//                                     : 
//                                     product.customFields?.find(field => field.key === 'custom-department').value === 'Accessories' ? 
//                                     product.name.replace('Adult Unisex', '') 
//                                     : 
//                                     product.name.split(" ").slice(1).join(" ")} */}
//                                     {
//                                     genderedCategories.includes(titleSubheading) ? 
//                                     product.name.replace(titleSubheading, '') :
//                                     product.name}
//                                 </div>
//                             </a>
//                     </>
//                 ) : (
//                     <a class="customizer-product-card"
//                         href="#customizer" 
//                         data-gan={product.customFields.find(field => field.key === 'lig-master_id')?.value}
//                         data-customizer-background-img-url={customizerBackgroundImg}
//                         data-is-custom-product="true"
//                         data-is-kids-graphic={product.tags1.includes("is_kids_graphic::True")}
//                         data-is-hoodie-graphic={product.tags1.includes("is_hoodie_graphic::True")}
//                         data-is-tank-graphic={product.tags1.includes("is_tank_graphic::True")}
//                     >
//                         <div class="ns-product-name">{product.name}</div>
//                     </a>
//                 )}

//                 {!isCustomizerPage && paidPrice != 0 && (
//                     <div class={ns-price-container ${product.tags1.includes("is_bundle::True") ? 'ns-bundle-price-container' : ''}}>
//                         {/* {paidPrice < listPrice && (
//                             <span class="ns-old-price">{format(listPrice)}</span>
//                         )}
//                         <span class={paidPrice < listPrice ? "ns-discounted-price" : "ns-regular-price"}>
//                             {format(paidPrice)}
//                         </span> */}

//                         {paidPrice < listPrice && (
//                           <>{isSalePage ? <span style="font-weight: 600; margin-right: 2px;">MSRP: </span> : ''}
//                             <span class="ns-old-price">{format(listPrice)}</span>
//                           </>
//                         )}
//                         <span class={product.tags1.includes("is_bundle::True") ? "ns-compare-at-price" : paidPrice < listPrice ? "ns-discounted-price" : "ns-regular-price"}>
//                             {format(paidPrice)}
//                         </span>

//                         {(product.tags1.includes("is_bundle::True") && product.tags1.some(tag => tag.includes('bundle_MSRP::'))) && (
//                             <span class="ns-msrp-price" style={{opacity: 0.5, textDecoration: 'line-through', marginLeft: '5px'}}>{format(+product.tags1.find(tag => tag.includes('bundle_MSRP::')).substring(product.tags1.find(tag => tag.includes('bundle_MSRP::')).indexOf('::') + 3))}</span>
//                         )}
//                     </div>
//                 )}
//             </div>
//         </SerpElement>
//     );
// }

import { SerpElement, useAppState, useCurrencyFormatting, useProductFilters } from "@nosto/preact";
import { productImagePlaceholder } from "../helpers";
import { useRef, useState, useEffect } from "preact/hooks";

export default function Product({ product, isSidebarVisible }) {
    const { format } = useCurrencyFormatting();
    const [hoverImage, setHoverImage] = useState(null);
    const sliderRef = useRef(null);
    const [isDown, setIsDown] = useState(false);
    const [startX, setStartX] = useState(0);
    const [scrollLeft, setScrollLeft] = useState(0);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
    
    const { filters } = useProductFilters()

    const genderedCategories = ["Men's", "Women's", "Kids", "Boys", "Girls", "Toddler", "Infant"]
    const titleSubheading = product.name.split(" ")[0]
   
    const isSaleSkuForSearch = product?.skus[0].listPrice && product?.skus[0].listPrice > product?.skus[0].price
    const isSalePage = (window.location.href.includes("/collections/sale") && !window.location.href.includes("q=")) || isSaleSkuForSearch;
    const isCustomizerPage = window.location.href.includes("/collections/customizer");

    let bestsellingSku = product.skus?.find(sku => (sku.customFields?.find(field => field.key === 'custom-bestseller')?.value === 'true' && sku.customFields?.find(field => field.key === 'custom-sale_product')?.value !== 'true'))
    if(isSalePage) { 
        bestsellingSku = product.skus?.find(sku => (sku.customFields?.find(field => field.key === 'custom-bestseller')?.value === 'true' && sku.customFields?.find(field => field.key === 'custom-sale_product')?.value === 'true'))
    }

    let chosenColorVariantCode = bestsellingSku?.id ? '?variant=' + bestsellingSku.id : ''
    let chosenColorSku = null;

    // --- Updated Color Selection Logic ---
    filters?.filter(filter => filter.name === 'Color').forEach(filter => {
        const matchColorSku = product?.skus.find(
            sku => sku.customFields?.find(field => field.key === 'custom-base_color')?.value === filter.value
        );

        if (matchColorSku) {
            if (isSalePage) {
                // Prefer discounted SKU that matches the color
                const matchColorSaleSku = product.skus.find(
                    sku => sku.customFields?.find(field => field.key === 'custom-base_color')?.value === filter.value &&
                           sku.listPrice && sku.listPrice > sku.price
                );
                if (matchColorSaleSku) {
                    chosenColorSku = matchColorSaleSku;
                } else {
                    // Fall back to ANY discounted SKU if no color match
                    chosenColorSku = product.skus.find(sku => sku.listPrice && sku.listPrice > sku.price) || matchColorSku;
                }
            } else {
                chosenColorSku = matchColorSku;
            }
            chosenColorVariantCode = '?variant=' + chosenColorSku.id;
            return;
        }
    });

    // Fallback if no color filter
    if (!chosenColorSku && bestsellingSku) {
        chosenColorSku = bestsellingSku;
    }

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth < 768);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const extractUniqueSwatches = (skus, isSalePage) => {
        if (!Array.isArray(skus)) {
            return [];
        }
        const uniqueSwatches = new Map();
        skus.forEach((sku) => {
            const hexField = sku.customFields.find(field => field.key === "custom-hex_code");
            const isOnSale = sku.listPrice && sku.listPrice > sku.price

            if(sku.availability === 'OutOfStock') return
            if (isOnSale && !isSalePage) return;
            if (!isOnSale && isSalePage) return;

            if (hexField && !uniqueSwatches.has(hexField?.value)) {
                uniqueSwatches.set(hexField.value, [sku.imageUrl, sku.id]);
            }
        });
        return Array.from(uniqueSwatches.entries());
    };

    const swatches = extractUniqueSwatches(product.skus || [], isSalePage);

    const handleMouseDown = (e) => {
        if (sliderRef.current) {
            setIsDown(true);
            setStartX(e.pageX - sliderRef.current.offsetLeft);
            setScrollLeft(sliderRef.current.scrollLeft);
        }
    };

    const handleMouseLeave = () => setIsDown(false);
    const handleMouseUp = () => setIsDown(false);

    const handleMouseMove = (e) => {
        if (!isDown || !sliderRef.current) return;
        e.preventDefault();
        const x = e.pageX - sliderRef.current.offsetLeft;
        const walk = (x - startX) * 5; 
        sliderRef.current.scrollLeft = scrollLeft - walk;
    };

    const handleSwatchAction = (imageUrl, e, skuId) => {
        if (isMobile) {
            setHoverImage(imageUrl);
            e.target.closest(".ns-product-container").querySelectorAll("a").forEach((el) => {
                el.href = el.href.split("?")[0] + `?variant=${skuId}`
            })
        }
    };

    // --- Updated image and price assignment ---
    let prodUrl = product.url + chosenColorVariantCode;
    let listPrice = chosenColorSku?.listPrice ?? product.listPrice;
    let paidPrice = chosenColorSku?.price ?? product.price;
    let mainImg = chosenColorSku?.imageUrl ?? product.skus[0]?.imageUrl ?? product.imageUrl;
    let altImg = mainImg;

    let skuSpecificaltImgSkuCode = chosenColorSku?.customFields?.find(field => field.key === 'skucode')?.value;
    let skuSpecificaltImg;
    if(product.alternateImageUrls && skuSpecificaltImgSkuCode) { 
        for(let i = 9; i > 1; i--){
            if(product.alternateImageUrls?.find(img => img.includes(skuSpecificaltImgSkuCode.substring(0, skuSpecificaltImgSkuCode.indexOf('-')) + '_' + i))){
                skuSpecificaltImg = product.alternateImageUrls?.find(img => img.includes(skuSpecificaltImgSkuCode.substring(0, skuSpecificaltImgSkuCode.indexOf('-')) + '_' + i))
            }
        }        
    } 

    if(isCustomizerPage){
        mainImg = product.imageUrl
    }
    
    if(isSalePage) { 
        prodUrl = product.url + chosenColorVariantCode + (chosenColorVariantCode ? "&sale_value=true" : "?sale_value=true")
        if (!chosenColorSku) {
            product.skus?.some(function(el) {
                if(el.price < el.listPrice){
                    listPrice = el.listPrice;
                    paidPrice = el.price;
                    mainImg = el.imageUrl;
                    product.alternateImageUrls?.some(function(innerEl, idx) {
                        if(innerEl == mainImg) {
                            altImg = product.alternateImageUrls[idx + 1];
                            return true;
                        }
                    })
                    return true;
                }
            })
        }
    }

    let customizerBackgroundImg = ""
    if(product.tags1.includes("is_customizable::True") && !product.tags1.includes("is_disable_customizer::True")) {
        product.tags1?.some(function(tag) {
            if(tag.includes("customizer_background_image")) {
                customizerBackgroundImg = tag.toString().split("::")[1].trim()
            }
        })
    }

    return (
        <SerpElement
            as="div"
            hit={product}
            class="ns-product-container relative"
        >
            { product.tags1.includes("is_customizable::True") && !product.tags1.includes("is_disable_customizer::True") && (
                <button 
                    data-gan={product.customFields.find(field => field.key === 'custom-gan')?.value}
                    data-is-kids-graphic={product.tags1.includes("is_kids_graphic::True")} 
                    data-is-hoodie-graphic={product.tags1.includes("is_hoodie_graphic::True")}
                    data-is-tank-graphic={product.tags1.includes("is_tank_graphic::True")}
                    data-customizer-background-img-url={customizerBackgroundImg}
                    class="right-[5px] top-[5px] customizer-button body-12-med hover:bg-grey-6 ">
                        <span class="customizer-button-text">Customize</span>
                        <img src="https://cdn.shopify.com/s/files/1/0686/8326/8417/files/customizer-icon.png?v=1728055689" alt="Customize this product" height="12" width="12" loading="lazy" class="image customizer-button-image w-[12px] block object-fit " />
                </button>
            )}

            { isCustomizerPage ? (
                <a class={`ns-product-image-container customizer-product-card ${skuSpecificaltImg ? 'ns-multiple-images' : ''}`}
                    href="#customizer" 
                    data-gan={product.customFields.find(field => field.key === 'lig-master_id')?.value}
                    data-customizer-background-img-url={customizerBackgroundImg}
                    data-is-custom-product="true"
                    data-is-kids-graphic={product.tags1.includes("is_kids_graphic::True")}
                    data-is-hoodie-graphic={product.tags1.includes("is_hoodie_graphic::True")}
                    data-is-tank-graphic={product.tags1.includes("is_tank_graphic::True")}
                >
                    <div class="ns-badges-container">
                        {(paidPrice < listPrice && window.location.href.indexOf('collections/sale') === -1) && (
                            <span class="ns-sale-badge">On Sale!</span>
                        )}
                        {(product.tags1?.includes("badge::new") && window.location.href.indexOf('collections/new') === -1) && (
                            <span class="ns-new-badge">New!</span>
                        )}
                    </div>

                    <img
                        class={product.alternateImageUrls?.length > 0 && !isCustomizerPage ? "ns-primary-image" : "ns-regular-image"}
                        src={`${ mainImg || hoverImage || productImagePlaceholder}&width=400`}
                        alt={`Product image for "${product.name}"`}
                        width="600"
                        height="400"
                    />

                    {product.alternateImageUrls?.length > 0 && !isCustomizerPage && altImg != "" && !hoverImage && (
                        <img
                            class="ns-secondary-image"
                            src={`${skuSpecificaltImg || altImg || productImagePlaceholder}&width=400`}
                            alt={`Product image for "${product.name}"`}
                            width="600"
                            height="400"
                        />
                    )}
                </a>
            ) : (
                <a href={prodUrl} class={`ns-product-image-container ${skuSpecificaltImg ? 'ns-multiple-images' : ''}`}>
                    <div class="ns-badges-container">
                        {(paidPrice < listPrice && window.location.href.indexOf('collections/sale') === -1) && (
                            <span class="ns-sale-badge">On Sale!</span>
                        )}
                        {(product.tags1?.includes("badge::new") && window.location.href.indexOf('collections/new') === -1) && (
                            <span class="ns-new-badge">New!</span>
                        )}
                    </div>

                    <img
                        class={product.alternateImageUrls?.length > 0 && !isCustomizerPage && !isMobile ? "ns-primary-image" : "ns-regular-image"}
                        src={`${hoverImage || mainImg || productImagePlaceholder}&width=400`}
                        alt={`Product image for "${product.name}"`}
                        width="600"
                        height="400"
                    />

                    {!isMobile && product.alternateImageUrls?.length > 0 && !isCustomizerPage && altImg != "" && !hoverImage && (
                        <img
                            class="ns-secondary-image"
                            src={`${skuSpecificaltImg || altImg || productImagePlaceholder}&width=400`}
                            alt={`Product image for "${product.name}"`}
                            width="600"
                            height="400"
                        />
                    )}
                </a>
            )}

            {swatches.length > 0 && (
                <div class="ns-swatches-container">
                    <div
                        class="ns-swatches-inner"
                        onMouseDown={handleMouseDown}
                        onMouseLeave={handleMouseLeave}
                        onMouseUp={handleMouseUp}
                        onMouseMove={handleMouseMove}
                        ref={sliderRef}
                    >
                        <div class="ns-swatches">
                            {swatches.map(([hexCode, [imageUrl, id]], index) => (
                                <span
                                    key={index}
                                    class={`ns-swatch-item ${imageUrl === chosenColorSku?.imageUrl ? 'ns-bestselling-swatch' : ''}`}
                                    style={{ backgroundColor: hexCode }}
                                    onMouseEnter={() => !isMobile && setHoverImage(imageUrl)}
                                    onMouseLeave={() => !isMobile && setHoverImage(null)}
                                    onClick={(e) => {
                                        if (isMobile) {
                                            handleSwatchAction(imageUrl, e, id);
                                        } else {
                                            let saleParam = "";
                                            if(isSalePage) { saleParam = "&sale_value=true"; }
                                            window.location.href = `${product.url}?variant=${id}${saleParam}`;
                                        }
                                    }}
                                ></span>
                            ))}
                        </div>
                    </div>
                    {((!isMobile && swatches.length > 6) || (isMobile && swatches.length > 4)) && (
                        <span class="ns-more-swatches"
                            onClick={(e) => { e.currentTarget.closest(".ns-swatches-container").classList.toggle("showSwatches") }}>
                            <svg width="15" height="12" viewBox="0 0 15 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M5 1L11 6L5 11" stroke="#0A4875" stroke-linecap="round" />
                            </svg>
                        </span>
                    )}
                </div>
            )}

            <div class="ns-relative ns-product-info" data-nosto-element="product">
                {!isCustomizerPage && paidPrice != 0 ? (
                    <>
                        <div class="ns-product-category">
                            <span class={`${!genderedCategories.includes(titleSubheading) ? 'ns-transparent' : ''}`}>{titleSubheading}</span>
                        </div>
                        <a href={prodUrl}>
                            <div class="ns-product-name">
                                {genderedCategories.includes(titleSubheading) ? 
                                    product.name.replace(titleSubheading, '') :
                                    product.name}
                            </div>
                        </a>
                    </>
                ) : (
                    <a class="customizer-product-card"
                        href="#customizer" 
                        data-gan={product.customFields.find(field => field.key === 'lig-master_id')?.value}
                        data-customizer-background-img-url={customizerBackgroundImg}
                        data-is-custom-product="true"
                        data-is-kids-graphic={product.tags1.includes("is_kids_graphic::True")}
                        data-is-hoodie-graphic={product.tags1.includes("is_hoodie_graphic::True")}
                        data-is-tank-graphic={product.tags1.includes("is_tank_graphic::True")}
                    >
                        <div class="ns-product-name">{product.name}</div>
                    </a>
                )}

                {!isCustomizerPage && paidPrice != 0 && (
                    <div class={`ns-price-container ${product.tags1.includes("is_bundle::True") ? 'ns-bundle-price-container' : ''}`}>
                        {paidPrice < listPrice && (
                          <>{isSalePage ? <span style="font-weight: 600; margin-right: 2px;">MSRP: </span> : ''}
                            <span class="ns-old-price">{format(listPrice)}</span>
                          </>
                        )}
                        <span class={product.tags1.includes("is_bundle::True") ? "ns-compare-at-price" : paidPrice < listPrice ? "ns-discounted-price" : "ns-regular-price"}>
                            {format(paidPrice)}
                        </span>

                        {(product.tags1.includes("is_bundle::True") && product.tags1.some(tag => tag.includes('bundle_MSRP::'))) && (
                            <span class="ns-msrp-price" style={{opacity: 0.5, textDecoration: 'line-through', marginLeft: '5px'}}>{format(+product.tags1.find(tag => tag.includes('bundle_MSRP::')).substring(product.tags1.find(tag => tag.includes('bundle_MSRP::')).indexOf('::') + 3))}</span>
                        )}
                    </div>
                )}
            </div>
        </SerpElement>
    );
}
